var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          { staticClass: "info--template page-template page-transition" },
          [
            _c("div", { staticClass: "relative" }, [
              _c("div", { staticClass: "relative z-3000" }, [
                _c(
                  "section",
                  {
                    staticClass:
                      "relative mw12 flex flex-row z-1 z-content bg-beige",
                    attrs: { id: _vm.page.faq_section.slug },
                  },
                  [
                    _vm.isWindowWidthMobile == true
                      ? _c("div", { staticClass: "bg-cream w-100 dn-ns" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "container-fluid bg-cream relative z-4 overflow-hidden",
                            },
                            [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "f39px pb4 pt4 black-bottom is-blenny is-navy",
                                  attrs: { id: _vm.page.faq_section.slug },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.page.faq_section.title) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              ref: "mobileFAQContainer",
                              staticClass: "relative acc-height info-bb",
                              style: { "min-height": _vm.mobileMinHeight() },
                            },
                            [
                              _vm._l(
                                _vm.page.faq_section.faq_topics,
                                function (faq_topic, key) {
                                  return _c(
                                    "div",
                                    {},
                                    [
                                      _c(
                                        "accordion",
                                        {
                                          attrs: {
                                            type: "mobile-info",
                                            index: key,
                                            mobileActive: _vm.mobileActive,
                                          },
                                          on: {
                                            "update:mobileActive": function (
                                              $event
                                            ) {
                                              _vm.mobileActive = $event
                                            },
                                            "update:mobile-active": function (
                                              $event
                                            ) {
                                              _vm.mobileActive = $event
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "parent-nav-link" },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  staticClass:
                                                    "f26px is-tablet-bold",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(faq_topic.title) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "template",
                                            { slot: "sub-nav-links" },
                                            [
                                              _c(
                                                "div",
                                                {},
                                                _vm._l(
                                                  faq_topic.faqs,
                                                  function (questions) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "w-100 container-fluid question-answer",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "db pv4 f4 no-underline",
                                                            attrs: {
                                                              to: "questions",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "accordion",
                                                              {
                                                                attrs: {
                                                                  type: "desktop-info",
                                                                  closed: true,
                                                                  mobileFaqAnswerExpanded:
                                                                    _vm.mobileFaqAnswerExpanded,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "template",
                                                                  {
                                                                    slot: "parent-nav-link",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "h4",
                                                                      {
                                                                        staticClass:
                                                                          "f3 is-tablet-bold is-navy mr3 w-100",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                  " +
                                                                            _vm._s(
                                                                              questions.question
                                                                            ) +
                                                                            "\n                                "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "template",
                                                                  {
                                                                    slot: "sub-nav-links",
                                                                  },
                                                                  [
                                                                    questions.answer_text
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "f4 is-tablet-regular lh-20px cms-content pt4",
                                                                            domProps:
                                                                              {
                                                                                innerHTML:
                                                                                  _vm._s(
                                                                                    _vm.marked(
                                                                                      questions.answer_text
                                                                                    )
                                                                                  ),
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ],
                                                              2
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c("hr"),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isWindowWidthMobile == false
                      ? _c(
                          "div",
                          {
                            staticClass: "dn relative flex-ns flex-grow-1",
                            attrs: { id: _vm.page.faq_section.slug },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "mw6 w-100 pb5 pl5 minh-450" },
                              [
                                _c("div", { staticClass: "h-100" }, [
                                  _c(
                                    "div",
                                    { staticClass: "info-bg sticky-nav" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "pr5" },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "f98px mb4 is-blenny is-navy",
                                              attrs: {
                                                id: _vm.page.faq_section.slug,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.page.faq_section.title
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.page.faq_section.faq_topics,
                                            function (faq_topic, key) {
                                              return _c(
                                                "div",
                                                { staticClass: "pv2" },
                                                [
                                                  _c(
                                                    "accordion",
                                                    {
                                                      attrs: {
                                                        index: key,
                                                        desktopActive:
                                                          _vm.desktopActive,
                                                      },
                                                      on: {
                                                        "update:desktopActive":
                                                          function ($event) {
                                                            _vm.desktopActive =
                                                              $event
                                                          },
                                                        "update:desktop-active":
                                                          function ($event) {
                                                            _vm.desktopActive =
                                                              $event
                                                          },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "template",
                                                        {
                                                          slot: "parent-nav-link",
                                                        },
                                                        [
                                                          _c(
                                                            "h3",
                                                            {
                                                              staticClass:
                                                                "f26px is-tablet-bold",
                                                              class: {
                                                                active:
                                                                  _vm.desktopActive ==
                                                                  key,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    faq_topic.title
                                                                  ) +
                                                                  "\n                            "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "w-100 is-black mt6 pt5" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "pl4 pr6 mt4 mb5 z-4 relative",
                                  },
                                  _vm._l(
                                    _vm.page.faq_section.faq_topics,
                                    function (faq_topic, key) {
                                      return _c(
                                        "div",
                                        { staticClass: "z-4 relative" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.desktopActive == key,
                                                  expression:
                                                    "desktopActive == key",
                                                },
                                              ],
                                              staticClass: "b--is-black-50 bb",
                                              attrs: { id: faq_topic.slug },
                                            },
                                            _vm._l(
                                              faq_topic.faqs,
                                              function (questions, key) {
                                                return _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "b--is-black-50 bb pv4",
                                                    attrs: {
                                                      id: "faq-item-" + key,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "accordion",
                                                      {
                                                        attrs: {
                                                          type: "desktop-info",
                                                          closed: true,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "template",
                                                          {
                                                            slot: "parent-nav-link",
                                                          },
                                                          [
                                                            _c(
                                                              "h4",
                                                              {
                                                                ref: questions.question,
                                                                refInFor: true,
                                                                staticClass:
                                                                  "f3 is-tablet-bold is-navy pb1 mr4",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      questions.question
                                                                    ) +
                                                                    "\n                            "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "template",
                                                          {
                                                            slot: "sub-nav-links",
                                                          },
                                                          [
                                                            questions.answer_text
                                                              ? _c("div", {
                                                                  staticClass:
                                                                    "f4 is-tablet-regular pt4 lh-20px cms-content",
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        _vm.marked(
                                                                          questions.answer_text
                                                                        )
                                                                      ),
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "participateSection",
                staticClass: "relative bg-beige z-content",
              },
              [
                _c("div", { staticClass: "relative container-fluid" }, [
                  _c(
                    "section",
                    {
                      staticClass:
                        "relative center mw8-5 pt5 pb4 pb5-ns is-black",
                      attrs: { id: _vm.page.participate_section.slug },
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-xs-12 col-sm-4 ph3" }, [
                          _c("img", {
                            staticClass:
                              "db relative center img-responsive w-100",
                            attrs: {
                              src: _vm.page.participate_section.content["0"]
                                .image.src_image,
                              alt: _vm.page.participate_section.content["0"]
                                .image.alt,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "h3",
                            {
                              staticClass:
                                "f23px f38px-ns is-tablet-bold mt3 mb3 is-navy",
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.page.participate_section.content["0"]
                                      .title
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "f15px f18px-ns is-tablet-regular mb3 lh-copy cms-content",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.marked(
                                  _vm.page.participate_section.content["0"].text
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.page.participate_section.content["0"].cta.link
                            ? _c(
                                "a",
                                {
                                  staticClass: "f15px is-tablet-bold",
                                  attrs: {
                                    title:
                                      _vm.page.participate_section.content["0"]
                                        .cta.link_title,
                                    href: _vm.page.participate_section.content[
                                      "0"
                                    ].cta.link,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.page.participate_section.content["0"]
                                        .cta.text
                                    )
                                  ),
                                  _c("simple-svg", {
                                    staticClass: "checkout",
                                    attrs: {
                                      filepath: "/uploads/checkout-arrow.svg",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-12 col-sm-4 ph3" }, [
                          _c("img", {
                            staticClass:
                              "db relative center img-responsive w-100 pt4 pt0-m pt0-l",
                            attrs: {
                              src: _vm.page.participate_section.content["1"]
                                .image.src_image,
                              alt: _vm.page.participate_section.content["1"]
                                .image.alt,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "h3",
                            {
                              staticClass:
                                "f23px f38px-ns is-tablet-bold mt3 mb3 is-navy",
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.page.participate_section.content["1"]
                                      .title
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "f15px f18px-ns is-tablet-regular mb3 lh-copy cms-content",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.marked(
                                  _vm.page.participate_section.content["1"].text
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.page.participate_section.content["1"].cta
                            .link_title
                            ? _c(
                                "a",
                                {
                                  staticClass: "f15px is-tablet-bold",
                                  attrs: {
                                    title:
                                      _vm.page.participate_section.content["1"]
                                        .cta.link_title,
                                    href: _vm.page.participate_section.content[
                                      "1"
                                    ].cta.link,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.page.participate_section.content["1"]
                                        .cta.text
                                    )
                                  ),
                                  _c("simple-svg", {
                                    staticClass: "checkout",
                                    attrs: {
                                      filepath: "/uploads/checkout-arrow.svg",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-12 col-sm-4 ph3" }, [
                          _c("img", {
                            staticClass:
                              "db relative center img-responsive w-100 pt4 pt0-m pt0-l",
                            attrs: {
                              src: _vm.page.participate_section.content["2"]
                                .image.src_image,
                              alt: _vm.page.participate_section.content["2"]
                                .image.alt,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "h3",
                            {
                              staticClass:
                                "f23px f38px-ns is-tablet-bold mt3 mb3 is-navy",
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.page.participate_section.content["2"]
                                      .title
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "f15px f18px-ns is-tablet-regular mb3 lh-copy cms-content",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.marked(
                                  _vm.page.participate_section.content["2"].text
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.page.participate_section.content["2"].cta
                            .link_title
                            ? _c(
                                "a",
                                {
                                  staticClass: "f15px is-tablet-bold",
                                  attrs: {
                                    title:
                                      _vm.page.participate_section.content["2"]
                                        .cta.link_title,
                                    href: _vm.page.participate_section.content[
                                      "2"
                                    ].cta.link,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.page.participate_section.content["2"]
                                        .cta.text
                                    )
                                  ),
                                  _c("simple-svg", {
                                    staticClass: "checkout",
                                    attrs: {
                                      filepath: "/uploads/checkout-arrow.svg",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "fixedbg",
              {
                staticClass: "z-1",
                attrs: { background: _vm.page.reveal_content_section.image },
              },
              [
                _c("template", { slot: "contents" }, [
                  _c("div", { staticClass: "relative container-fluid" }, [
                    _c(
                      "section",
                      { staticClass: "relative mw8 center pv5 pv6-ns" },
                      [
                        _c("div", {
                          staticClass:
                            "f28px f38px-ns is-tablet-bold tl is-cream",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.marked(_vm.page.reveal_content_section.text)
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex mt4 flex-column flex-row-ns items-center",
                          },
                          _vm._l(
                            _vm.page.reveal_content_section.links,
                            function (item, index) {
                              return item.link && item.is_published
                                ? _c(
                                    "a",
                                    {
                                      key: "button-" + index,
                                      staticClass:
                                        "btn-generic has-red-bg mr4-ns mb4 mb0-m mb0-l",
                                      attrs: {
                                        href: item.link,
                                        title: item.title,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "text ttu is-lorano-reg",
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(item.title) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e()
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "relative bg-beige z-content" }, [
              _c("div", { staticClass: "relative bg-beige z-content" }, [
                _c("div", { staticClass: "relative container-fluid" }, [
                  _c(
                    "section",
                    {
                      staticClass:
                        "relative center mw8-5 pt3 pt5-ns pb5 pv5-ns is-black",
                      attrs: { id: _vm.page.accessibility_section.slug },
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "f98px-ns f39px is-blenny is-navy ttu mb3 mt4 mt0-m mt0-l",
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.page.accessibility_section.title) +
                              "\n              "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                          _c("img", {
                            staticClass:
                              "db relative center img-responsive w-100 mb3 mb0-m mb0-l",
                            attrs: {
                              src: _vm.page.accessibility_section.image
                                .src_image,
                              alt: _vm.page.accessibility_section.image.alt,
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 pl5-ns" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-column h-100 justify-center",
                              },
                              [
                                _c("div", [
                                  _c("div", {
                                    staticClass:
                                      "f15px f18px-ns is-tablet-regular mb3 lh-copy",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.marked(
                                          _vm.page.accessibility_section.text
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "f15px f18px-ns is-tablet-regular ttu is-teal link",
                                      attrs: {
                                        title:
                                          _vm.page.accessibility_section.cta
                                            .link_title,
                                        href: _vm.page.accessibility_section.cta
                                          .link,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.page.accessibility_section.cta
                                            .text
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.page.festival_map_section.is_published
                ? _c("div", { staticClass: "relative bg-beige z-content" }, [
                    _c("div", { staticClass: "relative container-fluid" }, [
                      _c(
                        "section",
                        {
                          staticClass: "relative center mw8-5 is-black",
                          attrs: { id: _vm.page.festival_map_section.slug },
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-8 col-md-10" },
                              [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "f98px-ns f39px is-blenny is-navy ttu pb2 pb4-ns",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.page.festival_map_section.title
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-sm-4 col-md-2 pb4 relative",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "f25px-ns f20px is-tablet-bold is-navy absolute-ns bottom-4 right-1 ttu",
                                    attrs: {
                                      title:
                                        _vm.page.festival_map_section.cta
                                          .link_title,
                                      href: _vm.page.festival_map_section.cta
                                        .link,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.festival_map_section.cta.text
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                              _c("img", {
                                staticClass:
                                  "db relative center img-responsive w-100",
                                attrs: {
                                  src: _vm.page.festival_map_section.main_map
                                    .image,
                                  alt: _vm.page.festival_map_section.title,
                                },
                              }),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "relative bg-beige z-content",
                  attrs: { id: _vm.page.partners_section.slug },
                },
                [
                  _c("div", { staticClass: "relative container-fluid" }, [
                    _c(
                      "section",
                      { staticClass: "relative center mw8-5 pt5 is-cream" },
                      [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c("div", { staticClass: "col-xs-12" }, [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "f98px-ns f39px is-blenny is-navy ttu mb3 mb4-ns",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.page.partners_section.title) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.page.partners_section.partners,
                              function (partner, index) {
                                return partner.is_published === true
                                  ? _c(
                                      "div",
                                      {
                                        key: "parnter-logos-" + index,
                                        staticClass:
                                          "col-xs-6 col-sm-4 col-md-2",
                                      },
                                      [
                                        partner.css_class
                                          ? _c("a", {
                                              directives: [
                                                {
                                                  name: "lazy",
                                                  rawName:
                                                    "v-lazy:background-image",
                                                  value: partner.image,
                                                  expression: "partner.image",
                                                  arg: "background-image",
                                                },
                                              ],
                                              staticClass:
                                                "image-zoom db relative mb3 aspect-ratio--1x1 bg-white partner-img",
                                              class: partner.css_class,
                                              attrs: {
                                                href: partner.link,
                                                target: "_blank",
                                                title: partner.title,
                                              },
                                            })
                                          : _c("a", {
                                              directives: [
                                                {
                                                  name: "lazy",
                                                  rawName:
                                                    "v-lazy:background-image",
                                                  value: partner.image,
                                                  expression: "partner.image",
                                                  arg: "background-image",
                                                },
                                              ],
                                              staticClass:
                                                "image-zoom db relative mb3 aspect-ratio--1x1 bg-white partner-img",
                                              attrs: {
                                                href: partner.link,
                                                target: "_blank",
                                                title: partner.title,
                                              },
                                            }),
                                      ]
                                    )
                                  : _vm._e()
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "relative bg-beige z-content" }, [
                _c("div", { staticClass: "relative container-fluid" }, [
                  _c(
                    "section",
                    {
                      staticClass: "relative center mw8-5 pt5 is-black",
                      attrs: { id: _vm.page.olworks_section.slug },
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "h3",
                          {
                            staticClass:
                              "f98px-ns f39px is-blenny is-navy ttu mb3 mb4-ns mt4 mt0-m mt0-l",
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.page.olworks_section.title) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                          _c("img", {
                            staticClass:
                              "db relative center img-responsive w-100 mb3 mb0-m mb0-l",
                            attrs: { src: _vm.page.olworks_section.image },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 pl5-ns" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-column h-100 justify-center",
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("div", {
                                      staticClass:
                                        "f15px f18px-ns is-tablet-regular mb3 lh-copy",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.marked(
                                            _vm.page.olworks_section.text
                                          )
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "f15px f18px-ns is-tablet-regular ttu is-red link",
                                        attrs: {
                                          title:
                                            _vm.page.olworks_section.cta_link
                                              .title,
                                          to: _vm.page.olworks_section.cta_link
                                            .link,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.olworks_section.cta_link
                                              .title
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "relative bg-beige z-content" }, [
                _c("div", { staticClass: "relative container-fluid" }, [
                  _c(
                    "section",
                    {
                      staticClass: "relative center mw8-5 pt5 pb5 is-black",
                      attrs: { id: _vm.page.take_action_section.slug },
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "h3",
                          {
                            staticClass:
                              "f98px-ns f39px is-blenny is-navy ttu mb3 mb4-ns mt4 mt0-m mt0-l",
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.page.take_action_section.title) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                          _c("img", {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy",
                                value: _vm.page.take_action_section.image,
                                expression: "page.take_action_section.image",
                              },
                            ],
                            staticClass:
                              "db relative center img-responsive w-100 mb3 mb0-m mb0-l",
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-6 pl5-ns" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-column h-100 justify-center",
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("div", {
                                      staticClass:
                                        "f15px f18px-ns is-tablet-regular mb3 lh-copy",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.marked(
                                            _vm.page.take_action_section.text
                                          )
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.page.take_action_section.cta &&
                                    _vm.page.take_action_section.cta.link
                                      ? _c(
                                          "router-link",
                                          {
                                            staticClass:
                                              "f15px f18px-ns is-tablet-regular ttu is-red link",
                                            attrs: {
                                              title: "Take a Stand",
                                              to: _vm.page.take_action_section
                                                .cta.link,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.page.take_action_section.cta
                                                  .title
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.isWindowWidthMobile == true
                ? _c("div", { staticClass: "relative bg-beige z-content" }, [
                    _c("div", { staticClass: "relative container-fluid" }, [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "f98px-ns f39px is-blenny is-navy ttu pt4",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.page.attractions_section.title) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "section",
                      {
                        staticClass: "relative center pt3 pb4 is-black",
                        attrs: { id: _vm.page.attractions_section.slug },
                      },
                      [
                        _c(
                          "swiper",
                          {
                            ref: "mySwiper",
                            staticClass: "container-fluid-important",
                            attrs: { options: _vm.swiperOptions },
                          },
                          _vm._l(
                            _vm.page.attractions_section.attractions,
                            function (item, index) {
                              return _c(
                                "swiper-slide",
                                { key: "park-attractions-m-" + index },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "relative container-fluid-full-width-xs",
                                    },
                                    [
                                      _c("div", { staticClass: "db w-100" }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "image-zoom2",
                                            attrs: {
                                              title: item.cta.link_title,
                                              href: item.cta.link,
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "relative aspect-ratio--1x1",
                                              style: {
                                                background:
                                                  "url(" +
                                                  item.image.src_image +
                                                  ")",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "f23px f38px-ns is-navy is-tablet-bold mt4 mb3 is-black",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(item.title) +
                                                    "\n                      "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "f15px f18px-ns is-tablet-regular mb3 lh-copy",
                                          domProps: {
                                            innerHTML: _vm._s(item.text),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "f15px f18px-ns is-tablet-regular ttu is-black",
                                            attrs: {
                                              title: item.cta.link_title,
                                              href: item.cta.link,
                                            },
                                          },
                                          [_vm._v(_vm._s(item.cta.text))]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isWindowWidthMobile == false
                ? _c("div", { staticClass: "relative bg-beige z-content" }, [
                    _c("div", { staticClass: "relative container-fluid" }, [
                      _c(
                        "section",
                        {
                          staticClass: "relative center mw8-5 is-black pt5",
                          attrs: { id: _vm.page.attractions_section.slug },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c("div", { staticClass: "col-xs-12" }, [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "f98px-ns f39px is-blenny is-navy ttu mb4",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.page.attractions_section.title
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.page.attractions_section.attractions,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "park-attractions-dt-" + index,
                                      staticClass: "col-xs-12 col-sm-4 pb5 ph3",
                                    },
                                    [
                                      _c("div", { staticClass: "w-100" }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "image-zoom2",
                                            attrs: {
                                              title: item.cta.link_title,
                                              href: item.cta.link,
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "relative aspect-ratio--1x1",
                                              style: {
                                                background:
                                                  "url(" +
                                                  item.image.src_image +
                                                  ")",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "f23px f38px-ns is-navy is-tablet-bold mt4 mb3 is-black",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(item.title) +
                                                    "\n                      "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        item.text
                                          ? _c("div", {
                                              staticClass:
                                                "f15px f18px-ns is-tablet-regular mb3 lh-copy",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.marked(item.text)
                                                ),
                                              },
                                            })
                                          : _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "f15px f18px-ns is-tablet-regular mb3 lh-copy",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(item.text) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "f15px f18px-ns is-tablet-regular ttu is-red link",
                                            attrs: {
                                              title: item.cta.link_title,
                                              href: item.cta.link,
                                            },
                                          },
                                          [_vm._v(_vm._s(item.cta.text))]
                                        ),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isWindowWidthMobile == true
                ? _c("div", { staticClass: "relative bg-beige z-content" }, [
                    _c("div", { staticClass: "relative container-fluid" }, [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "f98px-ns f39px is-blenny is-navy ttu pt4",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.page.the_neighborhood_section.title) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "section",
                      {
                        staticClass: "relative center pt3 pb4 s-black",
                        attrs: { id: _vm.page.the_neighborhood_section.slug },
                      },
                      [
                        _c(
                          "swiper",
                          {
                            ref: "mySwiper2",
                            staticClass: "container-fluid-important",
                            attrs: { options: _vm.swiperOptions },
                          },
                          _vm._l(
                            _vm.page.the_neighborhood_section.neighborhoods,
                            function (item, index) {
                              return _c(
                                "swiper-slide",
                                { key: "neighborhood-items-m-" + index },
                                [
                                  _c("div", { staticClass: "relative" }, [
                                    _c("div", { staticClass: "db w-100" }, [
                                      item.cta
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "image-zoom2",
                                              attrs: {
                                                title: item.cta.link_title,
                                                href: item.cta.link,
                                              },
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "relative aspect-ratio--1x1",
                                                style: {
                                                  background:
                                                    "url(" +
                                                    item.image.src_image +
                                                    ")",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "h3",
                                                {
                                                  staticClass:
                                                    "f23px f38px-ns is-navy is-tablet-bold mt4 mb3 is-black",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item.title) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "f15px f18px-ns is-tablet-regular mb3 lh-copy",
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(item.text) +
                                              "\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.cta && item.cta.is_published
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "f15px f18px-ns is-tablet-regular ttu is-red link",
                                              attrs: {
                                                title: item.cta.link_title,
                                                href: item.cta.link,
                                              },
                                            },
                                            [_vm._v(_vm._s(item.cta.text))]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isWindowWidthMobile == false
                ? _c("div", { staticClass: "relative bg-beige z-content" }, [
                    _c("div", { staticClass: "relative container-fluid" }, [
                      _c(
                        "section",
                        {
                          staticClass:
                            "relative center mw8-5 pb4 pb5-ns is-black",
                          attrs: { id: _vm.page.the_neighborhood_section.slug },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c("div", { staticClass: "col-xs-12" }, [
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "f98px-ns f39px is-blenny is-navy ttu mb4",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.page.the_neighborhood_section
                                            .title
                                        ) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.page.the_neighborhood_section.neighborhoods,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "neighborhood-item-" + index,
                                      staticClass: "col-xs-12 col-sm-4 pb4 ph3",
                                    },
                                    [
                                      _c("div", { staticClass: "w-100" }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "image-zoom2",
                                            attrs: {
                                              title: item.cta.link_title,
                                              href: item.cta.link,
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "relative aspect-ratio--1x1",
                                              style: {
                                                background:
                                                  "url(" +
                                                  item.image.src_image +
                                                  ")",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "f23px f38px-ns is-navy is-tablet-bold mt4 mb3 is-black",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(item.title) +
                                                    "\n                      "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "f15px f18px-ns is-tablet-regular mb3 lh-copy",
                                          domProps: {
                                            innerHTML: _vm._s(item.text),
                                          },
                                        }),
                                        _vm._v(" "),
                                        item.cta && item.cta.is_published
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "f15px f18px-ns is-tablet-regular ttu is-red",
                                                attrs: {
                                                  title: item.cta.link_title,
                                                  href: item.cta.link,
                                                },
                                              },
                                              [_vm._v(_vm._s(item.cta.text))]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }